import { httpClient } from '@/app/shared/services';
import { setHeader } from '@/app/shared/services';

import { apiConstants } from '../config';
import { PRODUCT_STORE, CLIENT_STORE } from '@/config';

const APP_URL = apiConstants.authApp; // api/app/auth
const AUTH_URL = apiConstants.auth; //api/client/auth

const CLIENT_URL = apiConstants.client; // api/client/clients
const CLIENT_BASE_URL = apiConstants.clientBase; // api/base/clients
const CLIENT_APP_URL = apiConstants.clientApp; // api/app/clients

const credentialsKey = 'credentials';
const tokenKey = 'token';

let _credentials = null;
let remember = true;


const LOOGGED_DATA = [ 'token','user_name','user_id', 'user_email', 'invitation_token', 'login_time', 'expires_in', 'register_id' ];


/**
 * Authenticates the user.
 * @param {string } password The login parameters.
 * @return {Promise<Credentials>} The user credentials.
 */
const login = (email, password) => {

  // setHeader({key: "X-Requested-With" , value: "XMLHttpRequest" });
  return httpClient.post(`${AUTH_URL}/login`, { email, password }).then(resp => {

    localStorage.removeItem(PRODUCT_STORE);
    removeClientAPPStore();
    removeClientStore();

    let response = resp.data.data

    // remember ? localStorage.setItem('token', respu.access_token) :
    // sessionStorage.setItem('token', respu.access_token);
    localStorage.setItem('token', response.access_token);
    localStorage.setItem('user_name', response.user.name);
    localStorage.setItem('user_id', response.user.id);
    localStorage.setItem('user_email', response.user.email);
    localStorage.setItem('invitation_token', response.user.invitation_token);
    localStorage.setItem('login_time', new Date());
    localStorage.setItem('expires_in',response.expires_in);
    
    return resp.data;
  });

};



/**
 * Authenticates the user.
 * @param {string } password The login parameters.
 * @return {Promise<Credentials>} The user app credentials.
 */
const loginApp = (email, password) => {

  return httpClient.post(`${APP_URL}/login`, { email, password })
  .then(resp => {

    let response = resp.data.data;
    
    localStorage.setItem('token', response.access_token);
    localStorage.setItem('invitation_token', response.user.invitation_token);
    localStorage.setItem('user_name', response.user.name);
    localStorage.setItem('user_id', response.user.id);
    localStorage.setItem('user_email', response.user.email);
    localStorage.setItem('login_time', new Date());
    localStorage.setItem('expires_in',response.expires_in);
    
    return resp.data;
  });

};



export const register = (client) => {
  return httpClient.post(`${CLIENT_BASE_URL}`, client).then(res => res.data);
}

export const validateTokenCaptcha = (data) => {
  return httpClient.post(`${CLIENT_BASE_URL}/validate`, data).then(res => res.data);
}



/**
 * Logs out the user and clear credentials.
 * @return True if the user was logged out successfully.
 */
const logout = ()  => {

  // this.setCredentials();
  return httpClient.get(`${AUTH_URL}/logout`).then(res => {

    sessionStorage.removeItem('token');

    LOOGGED_DATA.map( item => localStorage.removeItem(item) );
    
    localStorage.removeItem(PRODUCT_STORE);
    removeClientAPPStore();
    removeClientStore();

    return res.data;
  });
};

/**
 * Get the current logged client from token
 */
const getLoggedClient = () => {  // /me

  // clients/me
  setHeader({key: "Content-Type" , value: "application/json" });
  return httpClient.get(`${AUTH_URL}/user`).then(res => res.data); // res.data
};

/**
 * Get the current logged client from token
 */
const getLoggedClienApp = (email) => {  // /me
  setHeader({key: "Content-Type" , value: "application/json" });
  return httpClient.post(`${APP_URL}/user`, { email }).then(res => res.data); // res.data
};

const refresh = () => {
  setHeader({key: "X-Requested-With" , value: "XMLHttpRequest" });
  return httpClient.get(`${AUTH_URL}/refresh`).then(res => res);
};

const refreshAccessToken = () => {
  setHeader({ key: "X-Requested-With", value: "XMLHttpRequest" });
  return httpClient.get(`${AUTH_URL}/refresh`).then(res => {
    // console.error('refresh');

    localStorage.setItem("token", res.data.data.access_token);
    localStorage.setItem("login_time", new Date());

    setHeader({key: "Authorization" , value:  `Bearer ${res.data.data.access_token}`});

    return res.data
  });
};


const actualizarToken = (token) => {

  removeClientAPPStore();

  localStorage.setItem("token", token);
  localStorage.setItem("login_time", new Date());
  localStorage.setItem('expires_in', 3100); // 3600

  setHeader({key: "Authorization" , value:  `Bearer ${token}`});
}



const olvidoContrasenya = (email) => {
  return httpClient.post(`${AUTH_URL}/password-recovery/ask`, { email }).then(res => res);
};

const cambiarContrasenya = (token, password) => {
  setHeader({key: "Content-Type" , value: "application/json" });
  return httpClient.post(`${AUTH_URL}/password-recovery/update`, { token, password })
    .then(res => res);
};

// const solicitarEmailConfirm = (email) => {
//   return httpClient.post(`${AUTH_URL}/email-confirm/ask`, { email }).then(res => res);
// };

const solicitarEmailConfirm = () => {
  return httpClient.post(`${AUTH_URL}/verify-email/request`).then(res => res);
};

// export const confirmTestEmail = (token) => {
//   return httpClient.post(`${AUTH_URL}/email-confirm/update`, { token })
//   .then(res => res);
// }

// const validarEmailConfirm = (token, email) => {
//   setHeader({key: "Content-Type" , value: "application/json" });
//   return httpClient.post(`${AUTH_URL}/email-confirm/update`, { token, email })
//     .then(res => res);
// };


/**
 * Sets the user credentials.
 * The credentials may be persisted across sessions by setting the `remember` parameter to true.
 * Otherwise, the credentials are only persisted for the current session.
 * @param {Credentials=} credentials The user credentials.
 * @param {boolean=} remember True to remember credentials across sessions.
 */
const setCredentials = (credentials = null, remember = false) => {
  _credentials = credentials || null;

  if (credentials) {
    const storage = remember ? localStorage : sessionStorage;
    storage.setItem(tokenKey, credentials.access_token);
  } else {
    sessionStorage.removeItem(tokenKey);
    localStorage.removeItem(tokenKey);
  }
};

/**
 * Checks is the user is authenticated.
 * @return {boolean} True if the user is authenticated.
 */
const isAuthenticated = () => {
  return !!this.credentials;
}


/**
 * Gets the user credentials.
 * @return {Credentials} The user credentials or null if the user is not authenticated.
 */
const credentials = () => {
  return this._credentials;
}


const sendForgotPasswordRequest = (email) => {
  return httpClient.post(`${AUTH_URL}/password/email`, {email}).then( resp => resp ? true : false);
}

const sendPasswordRecovery = (passwordRecoveryObject) => {
  return httpClient.post(`${AUTH_URL}/password/reset`, passwordRecoveryObject)
    .then((resp) => {
      localStorage.setItem('token', resp.access_token);
      return true;
    });
}

const confirmEmail = (emailConfirmationToken) => {
  return httpClient.get(`${AUTH_URL}/confirm/${emailConfirmationToken}`)
    .then((resp) => {
      localStorage.setItem('token', resp.access_token);
      return resp;
    });
}


// /api/client/clients/verify-phone/{client_id}
export const setPhone = (client) => {
  return httpClient.post(`${CLIENT_URL}/verify-phone/${client.id}`, { phone: client.phone, phone_prefix: client.phone_prefix })
    .then((resp) => {
      return resp.data;
    });
}

// /api/client/clients/phone-verified/{client_id}
export const confirmPhone = (client_id, phoneToken) => {
  return httpClient.post(`${CLIENT_URL}/phone-verified/${client_id}`, {token: phoneToken })
    .then((resp) => {
      return resp.data;
    });
}

// /api/app/clients/verify-phone/{client_id}
export const setPhoneApp = (client) => {
  return httpClient.post(`${CLIENT_APP_URL}/verify-phone/${client.id}`, { phone: client.phone, phone_prefix: client.phone_prefix })
    .then((resp) => {
      return resp.data;
    });
}

// /api/client/clients/phone-verified/{client_id}
export const confirmPhoneApp = (client_id, phoneToken) => {
  return httpClient.post(`${CLIENT_APP_URL}/phone-verified/${client_id}`, {token: phoneToken })
    .then((resp) => {
      return resp.data;
    });
}

export const generateNewPin = (client_id) => {
  return httpClient.put(`${CLIENT_URL}/update-pin/${client_id}`)
    .then(r => {
      return r.data;
    });
}

export const setPassword = (clientData) => {
  return httpClient.put(`${CLIENT_BASE_URL}/password`, clientData )
    .then(r => r.data);
}

export const setCurrentRent = (planId) => {
  try {
    localStorage.setItem('plan_id', String(planId));
    return;
  } catch (e) {
  }
}

export const getCurrentRent = () => {
  return localStorage.getItem('plan_id');
}

export const getClientId = () => {
  return localStorage.getItem('client_id');
}

export const getInvitationToken = () => {
  return localStorage.getItem('invitation_token');
}

export const getToken = () =>
{
  return sessionStorage.getItem('token');
}

export const setClientStore = (clientData) => {
  return localStorage.setItem(CLIENT_STORE, JSON.stringify({ ...clientData}));
}

export const getClientStore = () => {
  return JSON.parse(localStorage.getItem(CLIENT_STORE));
}

export const removeClientStore = () => {
  return localStorage.removeItem(CLIENT_STORE);
}

export const removeClientAPPStore = () => {

  localStorage.removeItem('token');
  sessionStorage.removeItem('token');

  localStorage.removeItem('user_name');
  localStorage.removeItem('user_id');
  localStorage.removeItem('user_email');
  localStorage.removeItem('login_time');
  localStorage.removeItem('expires_in');
  localStorage.removeItem('role');
  localStorage.removeItem('invitation_token');

}





export {
  login,
  logout,
  refresh,
  refreshAccessToken,
  olvidoContrasenya,
  cambiarContrasenya,
  getLoggedClient,
  loginApp,
  getLoggedClienApp,
  actualizarToken,
  solicitarEmailConfirm,
  // validarEmailConfirm
};
